import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { persistor, store } from './store/reducers';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './i18n';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './resources/constants';
import { getAnalytics } from 'firebase/analytics';
import { initializeFirebaseAppCheck } from './config/firebase-app-check-config';
import { setupAxiosInterceptors } from './config/axios-interceptor';

// if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development') {
//     PiwikPro.initialize('f2576cca-8aba-492f-a169-df589f940d98', 'https://whatwatch.containers.piwik.pro');
// }

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container as HTMLElement);

const app = initializeApp(firebaseConfig);
getAnalytics(app);

// Inizializza Firebase App Check DOPO l'inizializzazione di Firebase
initializeFirebaseAppCheck(app);

// Configura gli interceptor di Axios per Firebase App Check
setupAxiosInterceptors();

root.render(
    <GoogleOAuthProvider clientId="418755584126-ml13d2ig765gv25u4785esvh5qrvi37s.apps.googleusercontent.com">
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </GoogleOAuthProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
